export default {
  showMoreLabel: {
    id: 'services_bouygues_offers_regional_benefit_show_more',
    defaultMessage: 'List of included regions',
  },
  showLessLabel: {
    id: 'services_bouygues_offers_regional_benefit_show_less',
    defaultMessage: 'Hide list of included regions',
  },
}
